/*
 * File: QuestionCard.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 9:51 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Components
import { Card } from '../Card';
import { Typography } from '../Typography';
import { ShareWidget as BaseShareWidget } from '../ShareWidget';
import { ClampContent } from '../ClampContent';


/**
 * Styles
 */

export const Wrapper = styled(Card)`
	padding: 16px 24px 14px;

	${({ $isPlaceholder }) => $isPlaceholder && css`
		pointer-events: none;

		* {
			pointer-events: none;
		}
	`}
`;

export const CardHeader = styled.div`
	width: 100%;
	display: flex;
	align-items: start;
	margin: 0px 0px 2px;
`;

export const ActionBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin: 14px 0px 0px;

	.share {
		font-size: 1.05rem;
	}
	.up {
		font-size: 1.0rem;
	}
	.comment {
		font-size: 1.0rem;
	}
	.active {
		color: ${({ theme }) => theme.brandHighlight};
		font-weight: 700;
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: -2px 0px 8px;
	gap: 6px;

	span {
		cursor: pointer;
	}
	svg {
		font-size: 0.7rem;
	}
	span {
		font-size: 0.8rem;
		margin-right: 4px;
	}
`;

export const ActionSpacer = styled.div`
	flex-grow: 1;
`;

export const UpvoteLabel = styled(Typography)``;

export const ShareActionContainer = styled.div`
	position: relative;
`;

export const ShareWidget = styled(BaseShareWidget)`
	left: 2px;
	bottom: 40px;
`;

export const QuestionClampContent = styled(ClampContent)`
	flex-grow: 1;
`;

export const ConfettiTarget = styled.div`
	position: absolute;
	top: 12px;
	left: 14px;
`;
